
class GuideSubject {
    constructor() {
        this.memberTeaser = document.querySelector("#member-teaser");
        this.navContainer = document.querySelector(".main-content__container__nav");
        this.h2s = document.querySelectorAll(".main-content__container__content h2");

        this.anchors = [];
        this.headings = [];

        if (this.navContainer) {
            if (!this.memberTeaser && this.h2s.length >= 3) {
                this.createNav();
                this.setFirstVisible();
                this.addEventListeners();
            } else {
                this.navContainer.remove();
            }
        }
    }

    createNav() {
        var ul = document.createElement("ul");
        [].forEach.call(this.h2s, h2 => {
            var id = "h2" + this.makeid(10);
            h2.id = id;
            this.headings.push(h2);
            ul.appendChild(this.getAnchorTemplate(id, h2.textContent).content.cloneNode(true));
            var anchor = ul.querySelector("a[data-target=" + id + "]");
            this.anchors.push(anchor);
        });
        this.navContainer.appendChild(ul);
    }

    setFirstVisible() {
        this.unselectAll();
        var first = null;
        [].forEach.call(this.headings, h2 => {
            if (this.elementInViewport2(h2)) {
                if (first === null || h2.offsetTop < first.offsetTop) {
                    first = h2;
                }
            }
        });
        if (first) {
            this.navContainer.querySelector("a[data-target=" + first.id + "]").classList.add("selected");
        }
    }

    unselectAll() {
        [].forEach.call(this.anchors, anchor => {
            anchor.classList.remove("selected");
        });
    }

    addEventListeners() {
        [].forEach.call(this.anchors, anchor => {
            anchor.addEventListener("click", e => {
                e.preventDefault();
                this.unselectAll();
                e.target.classList.add("selected");
                var target = document.querySelector("#" + anchor.dataset.target);
                if (target.parentElement.classList.contains("wrap-content--closed")) {
                    target.parentElement.classList.remove('wrap-content--closed');
                    target.parentElement.classList.add('wrap-content--open');
                    target.parentElement.nextSibling.classList.add('button__toggletext--open')
                    var svg = target.parentElement.nextElementSibling.querySelector('use');
                    target.parentElement.nextElementSibling.childNodes[0].nodeValue = 'Visa mindre';
                    svg.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '/icons/sprite.svg#chevron-up');
                }
                setTimeout(() => {
                    target.scrollIntoView();
                }, 10);
            });
        });
        document.addEventListener('scroll', (e) => {
            this.setFirstVisible();
        });
    }

    makeid(length) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() *
                charactersLength));
        }
        return result;
    }

    elementInViewport2(el) {
        var top = el.offsetTop;
        var left = el.offsetLeft;
        var width = el.offsetWidth;
        var height = el.offsetHeight;

        while (el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }

        return (
            top < (window.pageYOffset + window.innerHeight) &&
            left < (window.pageXOffset + window.innerWidth) &&
            (top + height) > window.pageYOffset &&
            (left + width) > window.pageXOffset
        );
    }

    getAnchorTemplate(target, text) {
        const tmpl = document.createElement('template');
        tmpl.innerHTML = `
            <li><a href="#${target}" data-target="${target}">${text}</a></li>
        `;
        return tmpl;
    }
}
document.addEventListener("DOMContentLoaded", function () {
    new GuideSubject();
});